import React from 'react';
import { VStack, Badge, Link, Text } from '@postenbring/hedwig-react';

const HitPostalCode = ({hit, hitIndex, localization}) => (
    <VStack gap="8" align="flex-start">
        <Badge size='smaller'>{localization.postalCode.categoryLabel}</Badge>
        <Text variant='h3' as="h2">{hit.heading}</Text>
        {hit.streetAddresses && (
            <p>{localization.postalCode.streetAddressLabel}</p>
        )}
        {hit.poBox && (
            <p>{localization.postalCode.poBoxLabel}</p>
        )}
        <Link href={hit.absoluteUrl} aria-describedby={"hit-" + hitIndex}>{localization.postalCode.linkLabel}</Link>
    </VStack>
);

export default HitPostalCode;
